import { WebSocketLink } from "@apollo/client/link/ws";
import createUploadLink from "apollo-upload-client/createUploadLink.mjs";
import { AuthenticationService } from "../services/authentication.service";

const createLink = (moduleCode: string) => () => createUploadLink({ uri: `${document.location.origin}/api/module/${moduleCode}/graphql` });

const wsProtocol = document.location.protocol === "http:" ? "ws:" : "wss:";

const createSubscriptionsLink = (moduleCode: string, authenticationService: AuthenticationService) => {
	const link = new WebSocketLink({
		uri: `${wsProtocol}//${document.location.host}/api/module/${moduleCode}/subscriptions`,
		options: {
			reconnect: true,
			reconnectionAttempts: 10,
			connectionParams: async () => {
				const user = await authenticationService.getUser();

				return {
					authToken: user?.access_token,
				};
			},
		},
	});

	setInterval(() => {
		try {
			(link as any).subscriptionClient.client?.send(JSON.stringify({ type: "ka" }));
		} catch {}
	}, 30000);

	return link;
};

const module1 = createLink("1");
const module3 = createLink("3");
const module4 = createLink("4");
const module5 = createLink("5");
export const dataSubscriptionsLink = (authenticationService: AuthenticationService) => createSubscriptionsLink("5", authenticationService);
export const moduleLibrarySubscriptions = (authenticationService: AuthenticationService) =>
	createSubscriptionsLink("1", authenticationService);

export const modelsLink = module1();
export const agreementsLink = module1();
export const casesLink = module3();
export const financialsLink = module4();
export const dataLink = module5();
